import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';

export function ConfirmValidator(params: {
  ctrlName: string;
  repeatCtrlName: string;
  errorName: FORM_ERRORS;
}): ValidatorFn {
  return (fg: FormGroup): ValidationErrors | null => {
    const ctrl = fg?.get(params.ctrlName);
    const repeatCtrl = fg?.get(params.repeatCtrlName);
    const isInvalid =
      ctrl?.value && repeatCtrl?.value && ctrl?.value !== repeatCtrl?.value;
    let repeatCtrlErrors = { ...repeatCtrl.errors };
    delete repeatCtrlErrors[params.errorName];
    if (isInvalid) {
      repeatCtrlErrors[params.errorName] = true;
    } else {
      if (Object.keys(repeatCtrlErrors || {})?.length === 0) {
        repeatCtrlErrors = null;
      }
    }
    repeatCtrl.setErrors(repeatCtrlErrors);
    return null;
  };
}
